'use client';

import NextThemesConfig from '@@config/next-themes';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { type ThemeProviderProps } from 'next-themes/dist/types';

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider {...NextThemesConfig} {...props}>
      {children}
    </NextThemesProvider>
  );
}
